module.exports = __webpack_public_path__ + "img/icon-bottom-arrow.19f25fdc.svg";